import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static values = {
        overlayClass: { type: String, default: 'show-overlay' },
        textClass: { type: String, default: 'show-text' }
    }

    showOverlay() {
        this.element.classList.add(this.overlayClassValue);
        this.element.classList.remove(this.textClassValue);
    }

    hideOverlay() {
        this.element.classList.remove(this.overlayClassValue);
    }

    showText() {
        this.element.classList.add(this.overlayClassValue);
        this.element.classList.add(this.textClassValue);
        window.dispatchEvent(new Event('resize'));
    }

    documentClick(event) {
        if (this.element.contains(event.target)) {
            return;
        }

        this.hideOverlay();
    }
}
